export enum SOCIAL {
  INSTAGRAM = "https://www.instagram.com/faire_wholesale/",
  FACEBOOK = "https://www.facebook.com/fairewholesale/",
  TWITTER = "https://twitter.com/faire_wholesale",
}
